import { Page } from "../../../types/pageTypes";
import ForecastAccuracyDetails from "./ForecastAccuracyDetails";

export const page: Page = {
    title: 'Forecast Accuracy Details',
    path: '/forecast-accuracy-details',
    icon: 'bullseye',
    component: ForecastAccuracyDetails
};
